<div
  #modalContents
  class="l-modal01__contents l-modal01__contents--w384 js-modal-contents"
  aria-modal="true"
  role="dialog"
  aria-labelledby="merge-confirm-modal-title"
>
  <!-- [モーダルheader] -->
  <div class="js-modal-head">
    <div #modalHead class="p-modal-head01">
      <h1
        id="merge-confirm-modal-title"
        class="p-modal-head01__title"
        [innerHTML]="'label.MargePlanListOnLogin' | staticMsg"
      ></h1>
      <button id="merge-confirm-modal-close" class="p-modal-head01__close js-modal-close" (click)="clickClose()">
        <span class="u-visually-hidden" [innerHTML]="'alt.closeModal' | staticMsg"></span>
      </button>
    </div>
  </div>
  <!-- [//モーダルheader] -->

  <!-- [モーダルbody] -->
  <div #modalBody class="l-modal01__body js-modal-body">
    <div class="merge-confirm__body-style">
      <div class="merge-confirm__body-margin">
        <!-- [マージ確認文言] -->
        <div class="c-plan-table01__col-item--em" [innerHTML]="'label.MargePlanListOnLoginExplain' | staticMsg"></div>
        <div class="merge-confirm__label-margin" [innerHTML]="'label.MargePlanListOnLoginNotify' | staticMsg"></div>
        <!-- [//マージ確認文言] -->

        <!-- [マージ確認ラジオボタン] -->
        <div class="c-form-element-radio" style="padding: 10px 0px">
          <asw-radio-group
            id="mergeConfirmRadioGroup"
            name="radioMerge"
            direction="vertical"
            [formControl]="mergeRadioFc"
          >
            <asw-radio-button id="mergeConfirmRadioButtonYes" value="1" label="{{ 'label.margeYes' | staticMsg }}">
            </asw-radio-button>
            <asw-radio-button id="mergeConfirmRadioButtonNo" value="2" label="{{ 'label.margeNo' | staticMsg }}">
            </asw-radio-button>
          </asw-radio-group>
        </div>
        <!-- [//マージ確認ラジオボタン] -->
      </div>
    </div>
  </div>
  <!-- [//モーダルbody] -->

  <!-- [モーダルfooter] -->
  <div #modalFooter class="js-modal-footer">
    <div style="padding: 12px 16px">
      <button id="merge-confirm-cancel-merge-button" class="c-btn-secondary c-btn-secondary--s">
        <button
          id="merge-confirm-cancel-merge-label"
          class="c-btn-secondary__text"
          [innerHTML]="'label.cancelMarge' | staticMsg"
          (click)="clickClose()"
        ></button>
      </button>
      <div style="float: right">
        <button id="merge-confirm-continue-merge-button" class="c-btn-primary c-btn-primary--s">
          <button
            id="merge-confirm-continue-merge-label"
            class="c-btn-primary__text"
            [innerHTML]="'label.continueMarge' | staticMsg"
            aswThrottleClick
            (throttleClick$)="clickContinue()"
          ></button>
        </button>
      </div>
    </div>
  </div>
  <!-- [//モーダルfooter] -->
</div>
